module.exports = __webpack_public_path__ + "img/off.32eb7a4a.svg";